import React, { useState } from 'react'
import { Col, Row } from 'antd'
import Rewards from '../studentprofilemain/rewards/rewards'

const achievementTypes = ['Milestones', 'Badges', 'Add-Ons']

const percentage = 80

const Studentachievement = () => {
  const [currentType, setCurrentType] = useState(achievementTypes[0])
   // eslint-disable-next-line
  const [currentItem, setCurrentItem] = useState(null)

  const rewardClick = (item: any) => {
    setCurrentItem(item)
  }

  return (
    <div>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={14}>
          <div className='flex flex-col border rounded-[30px] custom-primary-bg-three p-4'>
            <p className='font-semibold text-[22px] leading-[107%] text-appcolorwhite'>
              Camaraderie Cup
            </p>

            <div className='py-[5rem] flex justify-center'>
              <img src="/img/vectors/trophy.png" alt="trophy"
              className='w-[14rem] h-[14rem]'
              />
            </div>

            <div>
              <p className='mb-4 text-base text-appcolorwhite'>
                Description of reward and reason for earning. Describe the reward and reason for earning it,
                Description of reward and reason for earning
              </p>

              <div className='bg-appcolorwhite rounded-[30px] w-full h-[0.5rem] relative mt-3'>
                <div className='h-full bg-appcolorgreen rounded-[30px] flex justify-end'
                  style={{
                    width: percentage + '%'
                  }}
                >
                </div>
              </div>


              <div className='flex mt-[1.3rem]'>
                <div className='flex mr-[0.7rem] rounded-[20px] pt-[0.3rem] pb-[0.4rem] px-[0.8rem] items-center bg-appcolorblackfaintfive'>
                  <div className='mr-[0.4rem]'>
                    <img src="/img/vectors/key.svg" alt="key" className='w-[0.8re,] h-[0.8rem]' />
                  </div>
                  <span className='text-appcolorpurplefaintone text-base opacity-[0.5] font-bold'>20,000</span>
                </div>

                <div className='flex mr-[0.7rem] rounded-[20px] pt-[0.3rem] pb-[0.4rem] px-[0.8rem] items-center bg-appcoloryellowfaint'>
                  <div className='mr-[0.4rem]'>
                    <img src="/img/vectors/star.svg" alt="star" className='w-[0.8re,] h-[0.8rem]' />
                  </div>
                  <span className='text-appcolorpurplefaintone text-base opacity-[0.5] font-bold'>20,000</span>
                </div>
              </div>


            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={10}>
          <div>
            <div className='flex'>
              {
                achievementTypes.map((item) => (
                  <p key={`achievement-type-${item}`}
                    onClick={() => {
                      setCurrentType(item)
                    }}
                    className={`cursor-pointer mr-2 py-[0.5rem] px-4 w-fit text-appcolorblack opacity-[0.6] rounded-[10px] ${currentType === item ? 'font-bold bg-appcolorpurplefaint' : ''} hover:font-bold hover:bg-appcolorpurplefaint`}
                  >{item}</p>
                ))
              }
            </div>

            <div className='grid grid-flow-col grid-rows-2 gap-1 mt-8'>
              {
                [1, 3, 4, 5, 5, 5].map((item, index) => (
                  <div className='mb-4'
                    key={`reward-${index}-avatar`}
                  >
                    <Rewards
                      img={'/img/vectors/glossy.png'}
                      isBigger
                      rewardClick={rewardClick}
                      rewardDetails={{
                        name: 'reward'
                      }}
                    />
                  </div>
                ))
              }
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Studentachievement